import React, { useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import { CircularProgress } from "@mui/material";
import Button from "@mui/material/Button";
import { useTheme } from "@mui/material/styles";
import { Typography } from "@mui/material";

const DeleteCardDialog = ({ open, card, onClose, onDelete }) => {
  const [cardId, setCardId] = useState("");
  const [isRunning, setIsRunning] = useState(false);
  const theme = useTheme();

  useEffect(() => {
    if (card) {
      setCardId(card.id);
    }
  }, [card]);

  const handleDelete = async () => {
    setIsRunning(true);
    try {
      await onDelete(cardId);
    } finally {
      setIsRunning(false);
      onClose();
    }
  };

  const isAutomationCard = card?.widgets?.some(
    (widget) => widget.source === "automation"
  );

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Confirm Delete</DialogTitle>
      <DialogContent>
        <Typography variant="body1">Do you want to delete the card?</Typography>
        {isAutomationCard && (
          <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
            This won&apos;t delete the related automation.
          </Typography>
        )}
      </DialogContent>
      <DialogActions sx={{ justifyContent: "space-between", px: 2, pb: 2 }}>
        <Button
          onClick={onClose}
          disabled={isRunning}
          variant="outlined"
          sx={{
            textTransform: "none",
            boxShadow: "none",
            "&:hover": {
              boxShadow: "none",
            },
          }}
        >
          Cancel
        </Button>
        <Button
          onClick={handleDelete}
          disabled={isRunning}
          color="error"
          variant="contained"
          sx={{
            textTransform: "none",
            boxShadow: "none",
            "&:hover": {
              boxShadow: "none",
            },
          }}
        >
          Delete
          {isRunning && <CircularProgress size={16} sx={{ ml: 1 }} />}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export const BatchDeleteDialog = ({ open, count, onClose, onDelete }) => {
  const [isRunning, setIsRunning] = useState(false);

  const handleDelete = async () => {
    setIsRunning(true);
    try {
      await onDelete();
    } finally {
      setIsRunning(false);
      onClose();
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Confirm Delete</DialogTitle>
      <DialogContent>
        <Typography variant="body1">
          Are you sure you want to delete {count} selected card
          {count !== 1 ? "s" : ""}?
        </Typography>
      </DialogContent>
      <DialogActions sx={{ justifyContent: "space-between", px: 2, pb: 2 }}>
        <Button
          onClick={onClose}
          disabled={isRunning}
          variant="outlined"
          sx={{
            textTransform: "none",
            boxShadow: "none",
            "&:hover": {
              boxShadow: "none",
            },
          }}
        >
          Cancel
        </Button>
        <Button
          onClick={handleDelete}
          disabled={isRunning}
          color="error"
          variant="contained"
          sx={{
            textTransform: "none",
            boxShadow: "none",
            "&:hover": {
              boxShadow: "none",
            },
          }}
        >
          Delete
          {isRunning && <CircularProgress size={16} sx={{ ml: 1 }} />}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteCardDialog;
